module.exports = __webpack_public_path__ + "static/Coinbase-67e3894774e00dade82a13d95317c7a4.jpg";